var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"sctToaster_overlay\" ng-if=\"vm.toaster.isLoading\"></div>\n<div class=\"sctToaster sctToasterPosition-{{ vm.toaster.position }}\" ng-class=\"{\n      'sctToaster-isLoading': vm.toaster.isLoading,\n      'sctToaster-isFullWidth': vm.toaster.fullWidth\n     }\" ng-if=\"vm.toaster.isActive;\">\n<div>\n<div ng-if=\"!vm.toaster.isLoading\">\n<i class=\"ico-check-1\"></i> {{ vm.toaster.message }}\n</div>\n<div ng-if=\"vm.toaster.isLoading\">\n<i class=\"button_spinner\"></i> {{ vm.toaster.message }}\n</div>\n<a class=\"sctToaster_close\" ng-if=\"!vm.toaster.isLoading\" ng-click=\"vm.toaster.close()\">\n<i class=\"ico-cancel\"></i>\n</a>\n</div>\n</div>\n";
var id1="sct/sctToaster/sctToaster.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/components/sct/sctToaster/sctToaster.html
// module id = 1300
// module chunks = 1